"use client";

import React from "react";
import { Instagram, Music2, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
const socialLinks = [{
  id: "instagram",
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  id: "tiktok",
  icon: Music2,
  href: "#",
  label: "TikTok"
}, {
  id: "youtube",
  icon: Youtube,
  href: "#",
  label: "YouTube"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="175324" className="flex flex-wrap justify-center gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-6 w-24 rounded-md bg-muted/20 animate-pulse" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <NavigationMenu viewport={false} className="mx-auto">
      <NavigationMenuList className="flex-wrap justify-center gap-x-8 gap-y-4 space-x-0">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm font-medium text-muted-foreground transition-all duration-300 hover:text-primary hover:drop-shadow-[0_0_8px_var(--color-primary)] px-2 py-1 tracking-wide">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function TrainerFooter() {
  const currentYear = new Date().getFullYear();
  return <section id="hydroflush-serwis-co" className="dark bg-background text-foreground w-full relative overflow-hidden">
      {}
      <Separator className="bg-primary/40 h-[1px] w-full absolute top-0 left-0" />

      <div className="container mx-auto px-6 py-12 md:py-16">
        <div className="flex flex-col items-center justify-between gap-10 md:flex-row md:items-start">
          
          {}
          <div className="flex flex-col items-center md:items-start shrink-0">
            <Link to="/HomePage">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/fittrener_logo_footer.png" alt="Hydroflush" className="h-8 w-auto object-contain" />
            </Link>
          </div>

          {}
          <div className="flex-1 flex justify-center w-full md:w-auto">
            <MenuProvider menu_id="16">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex items-center gap-5 shrink-0">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.id} to={social.href} newTab aria-label={social.label} className="text-muted-foreground transition-all duration-300 hover:text-primary hover:-translate-y-1 hover:drop-shadow-[0_0_12px_var(--color-primary)]" data-index={i}>
                  <Icon className="size-6" strokeWidth={1.5} />
                </Link>;
          })}
          </div>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-border/20 flex flex-col items-center justify-between gap-4 md:flex-row text-[12px] text-muted-foreground font-mono tracking-widest uppercase">
          <p>
            &copy; {currentYear} Hydroflush. Wszelkie prawa zastrzeżone.
          </p>
          <p className="flex items-center gap-1">
            Płukanie instalacji CO • Pszczyna
          </p>
        </div>
      </div>
    </section>;
}